import { Injectable } from '@angular/core';
import {
  UnitOfMeasurementId,
  UnitsOfMeasurementIcons,
} from '@ordersnproducts/modules/shared/constants/units-of-measurement-icons';

@Injectable()
export class UnitOfMeasurementIconsService {
  constructor() {}

  /**
   * Returns the icon name corresponding to the given unit of measurement.
   *
   * @param {UnitOfMeasurementId} unitOfMeasure - The unit of measurement.
   * @returns {UnitsOfMeasurementIcons} - The corresponding icon name.
   */
  public getIconName(unitOfMeasure: UnitOfMeasurementId | number): UnitsOfMeasurementIcons {
    switch (unitOfMeasure) {
      case UnitOfMeasurementId.Bag:
        return UnitsOfMeasurementIcons.Bag;
      case UnitOfMeasurementId.Each:
        return UnitsOfMeasurementIcons.Each;
      case UnitOfMeasurementId.Loads:
        return UnitsOfMeasurementIcons.Loads;
      case UnitOfMeasurementId.Pallets:
        return UnitsOfMeasurementIcons.Pallets;
      case UnitOfMeasurementId.Tons:
        return UnitsOfMeasurementIcons.Tons;
      case UnitOfMeasurementId.CubicMeters:
        return UnitsOfMeasurementIcons.CubicMeters;
      default:
        return UnitsOfMeasurementIcons.Other;
    }
  }
}
